import { DESIGN_PAGE_TYPES_LIST } from '../constants/page-design';

export const DesignTypeLoader = {
    get: async function() {
        return await new Promise((resolve) => {
            resolve(DESIGN_PAGE_TYPES_LIST);
        });
    },
};

export const DesignTypeFilterLoader = {
    get: async function() {
        return await new Promise((resolve) => {
            resolve([{ id: 'all', name: '全部' }].concat(DESIGN_PAGE_TYPES_LIST));
        });
    },
};
